// extracted by mini-css-extract-plugin
export default {"cardInfor":"accessibility_cardInfor__FrcLX","body":"accessibility_body__JLFis","txt":"accessibility_txt__WNWeH"};